<template>
  <svg
    width="24"
    height="23"
    viewBox="0 0 24 23"
    fill="none"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m18.996 10.15-6.89 7.028-6.89-7.028M12.129 17.2V2.06"
      stroke-width="1.5"
      class="animate-download"
    />
    <path d="M1.15 20.7h21.875" stroke-width="1.5" />
  </svg>
</template>

<style scoped lang="scss">
.group:hover .animate-download {
  animation: download 1.15s 0.15s infinite ease-in-out;
  transform-origin: 50% 90%;
}

@keyframes download {
  0% {
    transform: translateY(0) scaleY(1);
    transform-origin: 50% 90%;
  }
  15% {
    transform: translateY(0.08em) scaleY(1);
  }
  35% {
    transform: translateY(0.04em) scaleY(0);
    transform-origin: 50% 90%;
  }
  45% {
    transform: translateY(0px) scaleY(0);
    transform-origin: 50% 0%;
  }
  55% {
    transform: translateY(0) scaleY(1);
    transform-origin: 50% 0%;
  }
  80% {
    transform-origin: 50% 90%;
  }
  100% {
    transform: translateY(0) scaleY(1);
    transform-origin: 50% 90%;
  }
}
</style>
